import { Form, message } from 'antd'
import { useEffect, useReducer } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import {
  ORDER_DELIVERY_UPDATE,
  NEW_SUPPLIER_ORDER,
  GET_OMS_EXPRESSCOMPANY_LIST,
  GET_SUPPLINER_ORDER_DETAIL,
} from '../../../../api/orderManage'
import {
  delModuleDataAction,
  setModuleDataAction,
} from '../../../../modules/pagecache'
import { useTypedSelector } from '../../../../redux/store'
import {
  isResponseCodeSuccess,
  getItemFromItemListByProperty,
} from '../../../../tools/util'
import { useCloseTab, useQuery } from '../../../../tools/utilHooks'

interface expressItem {
  expressCode: string
  expressCompany: string
}

interface State {
  currentPageState: any
  expressSelectList: expressItem[]
  isChangeDeliveryInfoModalVisible: boolean
  selectedRows: any[]
  isTableLoading?: boolean
  isDetailPage?: boolean
  expressSearchValue: string
  submitBtnLoading: boolean
}
const initialState: State = {
  currentPageState: undefined,
  expressSelectList: [],
  isChangeDeliveryInfoModalVisible: false,
  selectedRows: [],
  isTableLoading: false,
  expressSearchValue: '',
  submitBtnLoading: false,
}

type ActionType =
  | 'setCurrentPageState'
  | 'setExpressSelectList'
  | 'setIsChangeDeliveryInfoModalVisible'
  | 'setSelectedRows'
  | 'setIsTableLoading'
  | 'setIsDetailPage'
  | 'setExpressSearchValue'
  | 'setSubmitBtnLoading'

interface Action {
  type: ActionType
  payload: any
}

const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setCurrentPageState':
      newstate.currentPageState = action.payload
      return newstate
    case 'setExpressSelectList':
      newstate.expressSelectList = action.payload
      return newstate
    case 'setIsChangeDeliveryInfoModalVisible':
      newstate.isChangeDeliveryInfoModalVisible = action.payload
      return newstate
    case 'setSelectedRows':
      newstate.selectedRows = action.payload
      return newstate
    case 'setIsTableLoading':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setIsDetailPage':
      newstate.isDetailPage = action.payload
      return newstate
    case 'setExpressSearchValue':
      newstate.expressSearchValue = action.payload
      return newstate
    case 'setSubmitBtnLoading':
      newstate.submitBtnLoading = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

/**
 * 路由跳转时传过来的State
 * @param val
 * @returns
 */
const setCurrentPageState = (val: any): Action => ({
  type: 'setCurrentPageState',
  payload: val,
})
/**
 * 设置当前物流公司选择列表
 * @param val
 * @returns
 */
const setExpressSelectList = (val: any): Action => ({
  type: 'setExpressSelectList',
  payload: val,
})

/**
 * 设置修改物流信息弹出框的显示状态
 * @param val
 * @returns
 */
const setIsChangeDeliveryInfoModalVisible = (val: any): Action => ({
  type: 'setIsChangeDeliveryInfoModalVisible',
  payload: val,
})

/**
 * 设置选中的行的信息列表
 * @param val
 * @returns
 */
const setSelectedRows = (val: any): Action => ({
  type: 'setSelectedRows',
  payload: val,
})

/**
 * 物流下拉框搜索值
 * @param val
 * @returns
 */
const setExpressSearchValue = (val: string): Action => ({
  type: 'setExpressSearchValue',
  payload: val,
})

/**
 * 设置提交按钮的loading状态
 * @param val
 * @returns
 */
const setSubmitBtnLoading = (val: boolean): Action => ({
  type: 'setSubmitBtnLoading',
  payload: val,
})

export default function useHook() {
  const location = useLocation()
  const [state, dispatch] = useReducer(reducer, initialState)
  const {
    currentPageState,
    expressSelectList,
    isChangeDeliveryInfoModalVisible,
    isTableLoading,
    selectedRows,
    expressSearchValue,
    submitBtnLoading,
  } = state
  const { pathname } = location
  const query = useQuery()
  const id = query.get('id') || ''
  const [form] = Form.useForm()
  const [formModal] = Form.useForm()
  const { onCurrentPageClose } = useCloseTab()

  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const dispatchPageCache = useDispatch()
  const pagecachekey = 'AddSupplierDeliveryOrder'
  async function getExpressSelectData() {
    const res = await GET_OMS_EXPRESSCOMPANY_LIST()
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setExpressSelectList(res.data))
    } else {
      message.warning('物流公司列表请求失败')
    }
  }

  const handleDeleteRow = () => {
    if (selectedRows.length < 1) {
      message.warning('请先选择要删除的行')
      return
    }
    if (
      currentPageState?.selectedProductList.length - selectedRows.length <
      1
    ) {
      message.error('必须保留一行')
      return
    }
    const selectedIds = selectedRows.map((item) => {
      return item.id
    })
    dispatch(
      setCurrentPageState({
        ...currentPageState,
        selectedProductList: currentPageState.selectedProductList.filter(
          (item: any) => {
            return !selectedIds.includes(item.id)
          },
        ),
      }),
    )
  }
  const handleChangeDeliveryInfoClick = () => {
    dispatch(setIsChangeDeliveryInfoModalVisible(true))
  }
  const handleChangeDeliveryInfoCancel = () => {
    dispatch(setIsChangeDeliveryInfoModalVisible(false))
  }

  const handleDeliveryInfoSave = async () => {
    const formValues = await formModal.validateFields()
    dispatch(setSubmitBtnLoading(true))
    const expressName = getItemFromItemListByProperty(
      expressSelectList,
      'expressCode',
      formValues.expressCompany,
    )?.expressCompany
    const res = await ORDER_DELIVERY_UPDATE({
      expressCode: formValues.expressCompany,
      expressCompany: expressName,
      expressNo: formValues.expressNo,
      orderId: currentPageState?.id,
      deliveryId: id,
    })
    if (isResponseCodeSuccess(res.code)) {
      form.setFieldsValue({
        expressNo: formValues.expressNo,
        expressCompany: expressName,
      })
      message.success('变更发货单成功')
      formModal.resetFields()
      dispatch(setSubmitBtnLoading(false))
      dispatch(setIsChangeDeliveryInfoModalVisible(false))
    }
  }

  const isDetailPage = () => {
    if (pathname === '/srm/addsupplierdeliveryorder') {
      return false
    }
    return true
  }

  const handleTableChangeCheck = (
    selectedRowKeys: any,
    selectedRows: any[],
  ) => {
    dispatch(setSelectedRows(selectedRows))
  }

  const handleSubmit = async () => {

    const res0 = await GET_SUPPLINER_ORDER_DETAIL({
      id: currentPageState?.id,
    })
    if (isResponseCodeSuccess(res0.code)) {
      if (res0.data.orderState === '5' || res0.data.orderState === '7') {
        message.error('订单处于修改审核中，请联系相关采购处理')
        return;
      }
    }

    const formValues = await form.validateFields()
    dispatch(setSubmitBtnLoading(true))
    const productDetailList = currentPageState.selectedProductList.map(
      (item: any) => {
        const deliveryQty = formValues[item.id + 'deliveryQty']
        return {
          ...item,
          deliveryQty: deliveryQty,
          waitQty: item.num - deliveryQty,
        }
      },
    )
    const postDate = {
      productDetailList: productDetailList,
      id: currentPageState?.id,
      logisticsCompany: formValues.expressCompany,
      logisticsCode: getItemFromItemListByProperty(
        expressSelectList,
        'expressCompany',
        formValues.expressCompany,
      )?.expressCode,
      code: getItemFromItemListByProperty(
        expressSelectList,
        'expressCompany',
        formValues.expressCompany,
      )?.code,
      trackNum: formValues.expressNo,
      receiveMan: currentPageState?.receiveMan,
      receiveMobile: currentPageState?.receiveMobile,
      receiveAddress: currentPageState?.receiveAddress,
    }
    const res = await NEW_SUPPLIER_ORDER({ ...postDate })
    dispatch(setSubmitBtnLoading(false))
    if (isResponseCodeSuccess(res.code)) {
      message.success('发货成功')
      onCurrentPageClose(() => {
        dispatchPageCache(delModuleDataAction(pagecachekey))
      })
    }
  }

  const onExpressSearch = (val: string) => {
    dispatch(setExpressSearchValue(val))
  }

  const onExpressSelect = () => {
    dispatch(setExpressSearchValue(''))
  }

  useEffect(() => {
    if (!isDetailPage()) {
      const currentData = getItemFromItemListByProperty(
        pagekey,
        'key',
        pagecachekey,
      )?.data
      if (!location.state) {
        dispatch(setCurrentPageState(currentData))
      } else {
        // 订单详情里面没有发货单id
        const newState = {
          // eslint-disable-next-line @typescript-eslint/ban-types
          ...(location.state as {}),
        }
        dispatch(setCurrentPageState(newState))
        dispatchPageCache(
          setModuleDataAction({
            key: pagecachekey,
            data: newState,
          }),
        )
      }
    }
    // eslint-disable-next-line
  }, [])
  // 快递单，等当页state设置后
  useEffect(() => {
    if (currentPageState) {
      getExpressSelectData()
    }
    // eslint-disable-next-line
  }, [currentPageState])

  const isDetail = isDetailPage()
  return {
    currentPageState,
    expressSelectList,
    form,
    formModal,
    id,
    isChangeDeliveryInfoModalVisible,
    isTableLoading,
    pathname,
    isDetail,
    expressSearchValue,
    submitBtnLoading,
    isDetailPage,
    handleChangeDeliveryInfoClick,
    handleChangeDeliveryInfoCancel,
    handleDeleteRow,
    handleDeliveryInfoSave,
    handleSubmit,
    handleTableChangeCheck,
    onExpressSearch,
    onExpressSelect,
  }
}
import { Form, message } from 'antd'
import { useEffect, useReducer } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import {
  ORDER_DELIVERY_UPDATE,
  NEW_SUPPLIER_ORDER,
  GET_OMS_EXPRESSCOMPANY_LIST,
  GET_SUPPLINER_ORDER_DETAIL,
} from '../../../../api/orderManage'
import {
  delModuleDataAction,
  setModuleDataAction,
} from '../../../../modules/pagecache'
import { useTypedSelector } from '../../../../redux/store'
import {
  isResponseCodeSuccess,
  getItemFromItemListByProperty,
} from '../../../../tools/util'
import { useCloseTab, useQuery } from '../../../../tools/utilHooks'

interface expressItem {
  expressCode: string
  expressCompany: string
}

interface State {
  currentPageState: any
  expressSelectList: expressItem[]
  isChangeDeliveryInfoModalVisible: boolean
  selectedRows: any[]
  isTableLoading?: boolean
  isDetailPage?: boolean
  expressSearchValue: string
  submitBtnLoading: boolean
}
const initialState: State = {
  currentPageState: undefined,
  expressSelectList: [],
  isChangeDeliveryInfoModalVisible: false,
  selectedRows: [],
  isTableLoading: false,
  expressSearchValue: '',
  submitBtnLoading: false,
}

type ActionType =
  | 'setCurrentPageState'
  | 'setExpressSelectList'
  | 'setIsChangeDeliveryInfoModalVisible'
  | 'setSelectedRows'
  | 'setIsTableLoading'
  | 'setIsDetailPage'
  | 'setExpressSearchValue'
  | 'setSubmitBtnLoading'

interface Action {
  type: ActionType
  payload: any
}

const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setCurrentPageState':
      newstate.currentPageState = action.payload
      return newstate
    case 'setExpressSelectList':
      newstate.expressSelectList = action.payload
      return newstate
    case 'setIsChangeDeliveryInfoModalVisible':
      newstate.isChangeDeliveryInfoModalVisible = action.payload
      return newstate
    case 'setSelectedRows':
      newstate.selectedRows = action.payload
      return newstate
    case 'setIsTableLoading':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setIsDetailPage':
      newstate.isDetailPage = action.payload
      return newstate
    case 'setExpressSearchValue':
      newstate.expressSearchValue = action.payload
      return newstate
    case 'setSubmitBtnLoading':
      newstate.submitBtnLoading = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

/**
 * 路由跳转时传过来的State
 * @param val
 * @returns
 */
const setCurrentPageState = (val: any): Action => ({
  type: 'setCurrentPageState',
  payload: val,
})
/**
 * 设置当前物流公司选择列表
 * @param val
 * @returns
 */
const setExpressSelectList = (val: any): Action => ({
  type: 'setExpressSelectList',
  payload: val,
})

/**
 * 设置修改物流信息弹出框的显示状态
 * @param val
 * @returns
 */
const setIsChangeDeliveryInfoModalVisible = (val: any): Action => ({
  type: 'setIsChangeDeliveryInfoModalVisible',
  payload: val,
})

/**
 * 设置选中的行的信息列表
 * @param val
 * @returns
 */
const setSelectedRows = (val: any): Action => ({
  type: 'setSelectedRows',
  payload: val,
})

/**
 * 物流下拉框搜索值
 * @param val
 * @returns
 */
const setExpressSearchValue = (val: string): Action => ({
  type: 'setExpressSearchValue',
  payload: val,
})

/**
 * 设置提交按钮的loading状态
 * @param val
 * @returns
 */
const setSubmitBtnLoading = (val: boolean): Action => ({
  type: 'setSubmitBtnLoading',
  payload: val,
})

export default function useHook() {
  const location = useLocation()
  const [state, dispatch] = useReducer(reducer, initialState)
  const {
    currentPageState,
    expressSelectList,
    isChangeDeliveryInfoModalVisible,
    isTableLoading,
    selectedRows,
    expressSearchValue,
    submitBtnLoading,
  } = state
  const { pathname } = location
  const query = useQuery()
  const id = query.get('id') || ''
  const [form] = Form.useForm()
  const [formModal] = Form.useForm()
  const { onCurrentPageClose } = useCloseTab()

  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const dispatchPageCache = useDispatch()
  const pagecachekey = 'AddSupplierDeliveryOrder'
  async function getExpressSelectData() {
    const res = await GET_OMS_EXPRESSCOMPANY_LIST()
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setExpressSelectList(res.data))
    } else {
      message.warning('物流公司列表请求失败')
    }
  }

  const handleDeleteRow = () => {
    if (selectedRows.length < 1) {
      message.warning('请先选择要删除的行')
      return
    }
    if (
      currentPageState?.selectedProductList.length - selectedRows.length <
      1
    ) {
      message.error('必须保留一行')
      return
    }
    const selectedIds = selectedRows.map((item) => {
      return item.id
    })
    dispatch(
      setCurrentPageState({
        ...currentPageState,
        selectedProductList: currentPageState.selectedProductList.filter(
          (item: any) => {
            return !selectedIds.includes(item.id)
          },
        ),
      }),
    )
  }
  const handleChangeDeliveryInfoClick = () => {
    dispatch(setIsChangeDeliveryInfoModalVisible(true))
  }
  const handleChangeDeliveryInfoCancel = () => {
    dispatch(setIsChangeDeliveryInfoModalVisible(false))
  }

  const handleDeliveryInfoSave = async () => {
    const formValues = await formModal.validateFields()
    dispatch(setSubmitBtnLoading(true))
    const expressName = getItemFromItemListByProperty(
      expressSelectList,
      'expressCode',
      formValues.expressCompany,
    )?.expressCompany
    const res = await ORDER_DELIVERY_UPDATE({
      expressCode: formValues.expressCompany,
      expressCompany: expressName,
      expressNo: formValues.expressNo,
      orderId: currentPageState?.id,
      deliveryId: id,
    })
    if (isResponseCodeSuccess(res.code)) {
      form.setFieldsValue({
        expressNo: formValues.expressNo,
        expressCompany: expressName,
      })
      message.success('变更发货单成功')
      formModal.resetFields()
      dispatch(setSubmitBtnLoading(false))
      dispatch(setIsChangeDeliveryInfoModalVisible(false))
    }
  }

  const isDetailPage = () => {
    if (pathname === '/srm/addsupplierdeliveryorder') {
      return false
    }
    return true
  }

  const handleTableChangeCheck = (
    selectedRowKeys: any,
    selectedRows: any[],
  ) => {
    dispatch(setSelectedRows(selectedRows))
  }

  const handleSubmit = async () => {

    const res0 = await GET_SUPPLINER_ORDER_DETAIL({
      id: currentPageState?.id,
    })
    if (isResponseCodeSuccess(res0.code)) {
      if (res0.data.orderState === '5' || res0.data.orderState === '7') {
        message.error('订单处于修改审核中，请联系相关采购处理')
        return;
      }
    }

    const formValues = await form.validateFields()
    dispatch(setSubmitBtnLoading(true))
    const productDetailList = currentPageState.selectedProductList.map(
      (item: any) => {
        const deliveryQty = formValues[item.id + 'deliveryQty']
        return {
          ...item,
          deliveryQty: deliveryQty,
          waitQty: item.num - deliveryQty,
        }
      },
    )
    const postDate = {
      productDetailList: productDetailList,
      id: currentPageState?.id,
      logisticsCompany: formValues.expressCompany,
      logisticsCode: getItemFromItemListByProperty(
        expressSelectList,
        'expressCompany',
        formValues.expressCompany,
      )?.expressCode,
      code: getItemFromItemListByProperty(
        expressSelectList,
        'expressCompany',
        formValues.expressCompany,
      )?.code,
      trackNum: formValues.expressNo,
      receiveMan: currentPageState?.receiveMan,
      receiveMobile: currentPageState?.receiveMobile,
      receiveAddress: currentPageState?.receiveAddress,
    }
    const res = await NEW_SUPPLIER_ORDER({ ...postDate })
    dispatch(setSubmitBtnLoading(false))
    if (isResponseCodeSuccess(res.code)) {
      message.success('发货成功')
      onCurrentPageClose(() => {
        dispatchPageCache(delModuleDataAction(pagecachekey))
      })
    }
  }

  const onExpressSearch = (val: string) => {
    dispatch(setExpressSearchValue(val))
  }

  const onExpressSelect = () => {
    dispatch(setExpressSearchValue(''))
  }

  useEffect(() => {
    if (!isDetailPage()) {
      const currentData = getItemFromItemListByProperty(
        pagekey,
        'key',
        pagecachekey,
      )?.data
      if (!location.state) {
        dispatch(setCurrentPageState(currentData))
      } else {
        // 订单详情里面没有发货单id
        const newState = {
          // eslint-disable-next-line @typescript-eslint/ban-types
          ...(location.state as {}),
        }
        dispatch(setCurrentPageState(newState))
        dispatchPageCache(
          setModuleDataAction({
            key: pagecachekey,
            data: newState,
          }),
        )
      }
    }
    // eslint-disable-next-line
  }, [])
  // 快递单，等当页state设置后
  useEffect(() => {
    if (currentPageState) {
      getExpressSelectData()
    }
    // eslint-disable-next-line
  }, [currentPageState])

  const isDetail = isDetailPage()
  return {
    currentPageState,
    expressSelectList,
    form,
    formModal,
    id,
    isChangeDeliveryInfoModalVisible,
    isTableLoading,
    pathname,
    isDetail,
    expressSearchValue,
    submitBtnLoading,
    isDetailPage,
    handleChangeDeliveryInfoClick,
    handleChangeDeliveryInfoCancel,
    handleDeleteRow,
    handleDeliveryInfoSave,
    handleSubmit,
    handleTableChangeCheck,
    onExpressSearch,
    onExpressSelect,
  }
}
